import * as React from "react";
import Styles from "./textfield.module.scss";
// import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { makeStyles, MenuItem, Select } from "@material-ui/core";
// import MobileDatePicker from "@mui/lab/MobileDatePicker";
// import { useDispatch } from "react-redux";

interface TextInputProps {
  id?: string;
  labelid?: string;
  label: string;
  inputType?: string;
  inputShrink?: boolean;
  notRequired?: boolean;
  InputHelper?: string;
  inputSelect?: boolean;
  inputOption?: string[] | number[];
  selectOption?: any[];
  multiline?: boolean;
  inputName: string;
  rows?: number;
  style?: React.CSSProperties;
  inputValue?: string | number;
  handleChange?: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement | any
  >;
}

const CustomSelect = (props: TextInputProps) => {
  const {
    labelid,
    label,
    id = "standard",
    inputType,
    notRequired,
    InputHelper,
    inputShrink,
    inputSelect = false,
    selectOption,
    multiline = false,
    inputName,
    inputValue,
    style,
    rows,
    handleChange,
  } = props;
  const useStyles = makeStyles({
    root: { color: "orange !important" },
    cssFocused: {
      fontFamily: "Kumbh Sans",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "12px !important",
      lineHeight: "16px",
      color: "#757575 !important",
      textTransform: "uppercase",
    },
    cssLabel: {
      color: "rgba(255, 255, 255, 0.81)",
      backgroundColor: "white",
      // border: "1px solid red",
    },
    cssOutlinedInput: {
      "&$cssFocused $notchedOutline": {
        borderColor: `#757575 !important`,
        borderWidth: "1px !important",
      },
    },
    notchedOutline: {
      borderColor: "#757575 !important",
    },
    helperText: {
      fontFamily: "Kumbh Sans !important",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "15px",
      color: "#757575 !important",
    },
  });
  const classes = useStyles();
  return (
    <Select
      fullWidth={true}
      labelId={labelid}
      id={id}
      name={inputName}
      value={inputValue}
      label={label}
      onChange={(e) => handleChange && handleChange(e)}
    >
      {selectOption?.map((x: any) => (
        <MenuItem key={x.name} value={x.value}>
          {x.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CustomSelect;
